import React from "react";
import contextProvider from "../../contextProvider";
import { ButtonGroup } from "reactstrap";

import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";

import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import ReactOModal from "../../_L1_components/Elements/ReactOModal";
import ReactOForm from "../../_L1_components/Elements/ReactOForm";
import ReactOFormInput from "../../_L1_components/Elements/ReactOFormInput";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";

class NotesEditor extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: true,
      data: null,
    };
    super(props, initState);
  }

  setTs(ts) {
    this._TS = ts;
  }

  getNotes() {
    if (this.props.onLoadingStarted) {
      this.props.onLoadingStarted();
    }
    this.setState(
      {
        loading_notes: true,
      },
      () => {
        this.callsSet.call(this._TS ? "get_measure_note_at" : "get_measure_note", {
          data_input: {
            ts: this._TS,
          },
          on_success: (response_status, response_data) => {
            if (this.props.onNewNotesAvailable) {
              this.props.onNewNotesAvailable(response_data[0].data, () => {
                this.setState({
                  loading_notes: false,
                });
                if (this.props.onLoadingStopped) {
                  this.props.onLoadingStopped();
                }
              });
            }
          },
        });
      }
    );
  }

  createNoteAt(ts) {
    this._notes_editing_modal.open({ _pre_ts: ts });
  }

  createNote(data, cb) {
    //		console.log("DEBUG :: ProbeMeasureExplorer _ createNote");
    this.callsSet.call("create_measure_note", {
      data_input: { value: data },
      on_success: (response_status, response_data) => {
        this.getNotes();
        if (cb) cb(response_status, response_data[0]);
      },
      on_error: (response_error, response_data) => {
        if (cb) cb(response_error, response_data[0]);
      },
    });
  }

  saveNote(data, cb) {
    //		console.log("DEBUG :: ProbeMeasureExplorer _ saveNote");
    this.callsSet.call("set_measure_note", {
      data_input: {
        noteid: data.id,
        value: data,
      },
      on_success: (response_status, response_data) => {
        this.getNotes();
        if (cb) cb(response_status, response_data[0]);
      },
      on_error: (response_error, response_data) => {
        if (cb) cb(response_error, response_data[0]);
      },
    });
  }

  deleteNote(data, cb) {
    //		console.log("DEBUG :: ProbeMeasureExplorer _ deleteNote");
    this.callsSet.call("delete_measure_note", {
      data_input: {
        noteid: data.id,
      },
      on_success: (response_status, response_data) => {
        this.getNotes();
        if (cb) cb(response_status, response_data[0]);
      },
      on_error: (response_error, response_data) => {
        if (cb) cb(response_error, response_data[0]);
      },
    });
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        get_measure_note: {
          api_id: "get_measure_note",
          set_state: false,
          static_data: {
            probeuid: this.props.probeuid,
            measureid: this.props.measureid,
          },
        },
        get_measure_note_at: {
          api_id: "get_measure_note_at",
          set_state: false,
          static_data: {
            probeuid: this.props.probeuid,
            measureid: this.props.measureid,
          },
        },
        create_measure_note: {
          api_id: "create_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.probeuid,
            measureid: this.props.measureid,
          },
        },
        set_measure_note: {
          api_id: "set_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.probeuid,
            measureid: this.props.measureid,
          },
        },
        delete_measure_note: {
          api_id: "delete_measure_note",
          loading_key: "loading_set_notes",
          static_data: {
            probeuid: this.props.probeuid,
            measureid: this.props.measureid,
          },
        },
      },
    });

    if (this.props.onReady) {
      this.props.onReady({
        getNotes: this.getNotes.bind(this),
        setTs: this.setTs.bind(this),
        openListModal: () => {
          this._notes_modal.open();
        },
        openEditModal: (note) => {
          this._notes_editing_modal.open(note);
        },
        openDeleteModal: (note) => {
          this._notes_deleting_modal.open(note);
        },
        createNoteAt: this.createNoteAt.bind(this),
      });
    }
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <div>
        <ReactOModal
          modalId="notes_modal"
          loading={this.state.loading_notes}
          size="lg"
          onControllerReady={(modal_context) => {
            this._notes_modal = modal_context;
          }}
          header={(data) => {
            return (
              <div>
                <span className="icon-note mr-2" />
                Notes
              </div>
            );
          }}
          bodyClassName="p-0"
          body={(data) => {
            return this.props.notes ? (
              <div>
                <ReactOActionBar align="right">
                  <ReactOButton
                    icon="plus-circle"
                    color="primary"
                    onClick={() => {
                      this._notes_editing_modal.open();
                    }}
                  >
                    New note
                  </ReactOButton>
                </ReactOActionBar>
                <ReactOTable
                  thClassName="px-3 py-1"
                  tdClassName="align-middle px-3 py-2"
                  size="sm"
                  hoverable
                  compressed={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                  }
                  compressedRowRendering={(row_items) => {
                    return (
                      <div className="px-2 py-1">
                        <div>
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.ts.title}</strong>
                            </small>
                          </div>
                          {row_items.ts.content}
                        </div>
                        <div className="d-flex mt-2">
                          <div className="flex-grow-1">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.message.title}</strong>
                              </small>
                            </div>
                            {row_items.message.content}
                          </div>
                          <div className="align-self-center">
                            <div className="text-muted">
                              <small className="">
                                <strong>{row_items.actions.title}</strong>
                              </small>
                            </div>
                            {row_items.actions.content}
                          </div>
                        </div>
                      </div>
                    );
                  }}
                  thDividers
                  emptyMessage="No notes to show"
                  onRowClick={(row_data) => {
                    if (this.props.onGoToNote) {
                      this.props.onGoToNote(row_data.ts.value);
                      this._notes_modal.close();
                    }
                  }}
                  defaultSort={[
                    {
                      data_key: "ts",
                      order: "desc",
                    },
                  ]}
                  cols={[
                    {
                      title: "DATETIME",
                      data_key: "ts",
                      width: "40",
                      sortable: true,
                    },
                    {
                      title: "NOTE",
                      data_key: "message",
                      width: "40",
                      sortable: true,
                    },
                    {
                      data_key: "actions",
                      width: "20",
                    },
                  ]}
                  rows={(() => {
                    let _TMP = [];
                    (this.props.notes || []).forEach((_C_note, _C_idx) => {
                      _TMP.push({
                        index: _C_idx,
                        ts: {
                          value: _C_note.ts - 60,
                          render: (
                            <span>
                              {this.getAppContext()
                                .momentjs(_C_note.ts, "X")
                                .format("L LT")}
                            </span>
                          ),
                        },
                        message: {
                          value: _C_note.text,
                          render: (
                            <span
                              className={_C_note.type == "system" ? "font-italic" : ""}
                            >
                              {_C_note.text}
                            </span>
                          ),
                        },
                        actions: (
                          <ReactOActionBar padding="0" alignV="start" align="right">
                            <ButtonGroup>
                              <ReactOButton
                                icon="pencil"
                                color="gray150"
                                size="sm"
                                preventDefault
                                onClick={() => {
                                  this._notes_editing_modal.open(_C_note);
                                }}
                              />
                              <ReactOButton
                                icon="cancel"
                                color="danger"
                                size="sm"
                                preventDefault
                                onClick={() => {
                                  this._notes_deleting_modal.open(_C_note);
                                }}
                              />
                            </ButtonGroup>
                          </ReactOActionBar>
                        ),
                      });
                    });
                    return _TMP;
                  })()}
                />
              </div>
            ) : null;
          }}
        />

        <ReactOModal
          modalId="notes_editing_modal"
          loading={this.state.loading_set_notes}
          onControllerReady={(modal_context) => {
            this._notes_editing_modal = modal_context;
          }}
          onModalMounted={(data) => {
            let now_ts = this.getAppContext().momentjs().unix();
            now_ts = now_ts - (now_ts % 60);
            this._notes_editing_form.init(
              data
                ? data._pre_ts
                  ? { ts: data._pre_ts, text: "" }
                  : data
                : { ts: now_ts - 60, text: "" }
            );
          }}
          header={(data) => {
            return (
              <div>
                <span className="icon-note mr-2" />
                Notes
              </div>
            );
          }}
          body={(data) => {
            return (
              <div>
                <ReactOForm
                  unsavedWarning
                  onControllerReady={(form_controller) => {
                    this._notes_editing_form = form_controller;
                  }}
                  onSubmit={
                    data && !data._pre_ts
                      ? (form_data, cb) => {
                          this.saveNote(form_data, cb);
                        }
                      : (form_data, cb) => {
                          this.createNote(form_data, cb);
                        }
                  }
                >
                  <div>
                    <ReactOFormInput type="hidden" data_key="cssid" />
                    <ReactOFormInput
                      type="datetime-picker"
                      data_key="ts"
                      label="Datetime"
                      size="md"
                      default={this.getAppContext().momentjs().unix()}
                    />
                    <ReactOFormInput
                      className="mt-3"
                      type="textarea"
                      data_key="text"
                      label="Message"
                      placeholder="Type message here"
                      autofocus={data && (data._pre_ts || data.id) ? true : false}
                      size="md"
                      default=""
                      validators={[
                        {
                          func: (value) => {
                            return /^.+$/.test(value);
                          },
                          invalid_text: "Type a message",
                        },
                      ]}
                    />
                  </div>
                </ReactOForm>
              </div>
            );
          }}
          actions={[
            {
              text: "Cancel",
              color: "light",
              action: "close",
            },
            (data) => {
              return {
                text: data && !data._pre_ts ? "Save" : "Create",
                color: "primary",
                icon: "save",
                action: () => {
                  this._notes_editing_form.submit((submit_result) => {
                    if (submit_result.status === true) {
                      this._notes_editing_modal.close();
                    }
                  });
                },
              };
            },
          ]}
        />

        <ReactOModal
          modalId="notes_deleting_modal"
          loading={this.state.loading_set_notes}
          scrollable
          onControllerReady={(modal_context) => {
            this._notes_deleting_modal = modal_context;
          }}
          header={(data) => {
            return (
              <div>
                <span className="icon-note mr-2" />
                Delete note
              </div>
            );
          }}
          body={(data) => {
            return <div>A note will be deleted. Continue?</div>;
          }}
          actions={[
            {
              text: "Cancel",
              color: "light",
              action: "close",
            },
            (data) => {
              return {
                text: "Delete",
                color: "danger",
                icon: "delete",
                action: () => {
                  this.deleteNote(data, () => {
                    this._notes_deleting_modal.close();
                  });
                },
              };
            },
          ]}
        />
      </div>
    );
  }
}

export default contextProvider(NotesEditor, {
  define: null,
});
